import { ButtonERP } from "@finanedi.es/storybook"
import {
  useContactosCuentaBancariaById,
  useDeleteCuentaBancaria,
} from "api/Contacto.hook"
import DeleteModal from "common/components/Modal/DeleteModal"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import CardBankAcountContact, {
  CuentaBancariaContactoWithLogoProps,
} from "./Components/CardBankAcountContact/CardBankAcountContact"
import { ModalAccountContactCuentaBancaria } from "./Components/ModalAccountContactCuentaBancaria/ModalAccountContactCuentaBancaria"

export interface DeleteEntidadModalProps {
  show: boolean
  id?: string
}

export interface CreateEditEntidadModalProps {
  show: boolean
  isEdit?: CuentaBancariaContactoWithLogoProps | undefined
}
interface CuentasBancariasProps {
  id: string
}

const CuentasBancarias = ({ id }: CuentasBancariasProps) => {
  const { id: idContacto } = useParams<{ id: string }>()
  const { t } = useTranslation()
  const [showDeleteModal, setShowDeleteModal] =
    useState<DeleteEntidadModalProps>({
      show: false,
      id: undefined,
    })

  const [createOrEditModal, setCreateOrEditModal] =
    useState<CreateEditEntidadModalProps>({
      show: false,
      isEdit: undefined,
    })

  const onHideCreateOrEditModal = () =>
    setCreateOrEditModal({
      show: false,
      isEdit: undefined,
    })

  const hideModal = () =>
    setShowDeleteModal({
      show: false,
      id: undefined,
    })

  const { contactosCuentaBancariaById, contactosCuentaBancariaByIdRefetch } =
    useContactosCuentaBancariaById(id)

  const deleteCuentaBancaria = useDeleteCuentaBancaria({
    onSuccess: () => {
      contactosCuentaBancariaByIdRefetch()
      hideModal()
    },
  })

  const handleDeleteConfirm = async () => {
    if (!showDeleteModal?.id) return
    await deleteCuentaBancaria(showDeleteModal.id)
  }

  return (
    <section className='tw-h-full tw-overflow-hidden'>
      <div className='tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-px-6 tw-py-6'>
        <span className='tw-text-xl tw-font-medium tw-h-fit'>
          {t("contactos.cuentasBancarias.title")}
        </span>
        <ButtonERP
          customize={{
            size: "md",
            type: "primary",
          }}
          onClick={() => {
            setCreateOrEditModal({
              show: true,
              isEdit: undefined,
            })
          }}
          label={`${t("contactos.cuentasBancarias.addAccount")}`}
        />
      </div>
      <div className='tw-w-full tw-h-[calc(100%-84px)] tw-overflow-y-auto tw-grid tw-grid-cols-[repeat(auto-fit,minmax(0,380px))] tw-gap-6 tw-px-6 tw-pb-6'>
        {contactosCuentaBancariaById?.map((bankAccount) => (
          <div
            key={bankAccount.id}
            className='tw-h-auto tw-flex tw-flex-col'
          >
            <CardBankAcountContact
              bankAccount={bankAccount}
              setShowDeleteModal={setShowDeleteModal}
              setCreateOrEditModal={setCreateOrEditModal}
              contactosCuentaBancariaByIdRefetch={
                contactosCuentaBancariaByIdRefetch
              }
            />
          </div>
        ))}
      </div>

      <DeleteModal
        visible={showDeleteModal.show}
        onHide={hideModal}
        size='small'
        iconType='remesas'
        buttonLabel={t("bancos.delete.confirmButton")}
        title={t("bancos.delete.labelTitle")}
        message={t("bancos.delete.msg")}
        onCancel={hideModal}
        onConfirm={handleDeleteConfirm}
      />

      {idContacto && (
        <ModalAccountContactCuentaBancaria
          id={idContacto}
          createOrEditModal={createOrEditModal}
          onHide={onHideCreateOrEditModal}
          contactosCuentaBancariaByIdRefetch={
            contactosCuentaBancariaByIdRefetch
          }
        />
      )}
    </section>
  )
}

export default CuentasBancarias
